import request from '@/utils/request';

// 获取服务类型列表
export function getServiceTypeList(data) {
  return request({
    url: '/car/service-type',
    method: 'get',
    params: data,
  });
}

// 获取详情
export function getServiceTypeDetail(id) {
  return request({
    url: '/car/service-type/' + id,
    method: 'get',
  });
}

// 删除
export function deleteServiceType(id) {
  return request({
    url: '/car/service-type/' + id,
    method: 'delete',
  });
}
//新增
export function addServiceType(data) {
  return request({
    url: '/car/service-type',
    method: 'post',
    data,
  });
}
//修改
export function updateServiceType(data) {
  return request({
    url: '/car/service-type/' + data.id,
    method: 'put',
    data,
  });
}

//不分页列表
export function getServiceTypeCountList() {
  return request({
    url: '/car/service-type/selectListWithCount',
    method: 'get',
  });
}

//不分页列表
export function getAllServiceTypeList() {
  return request({
    url: '/car/service-type/selectList',
    method: 'get',
  });
}
